// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@supports (mix-blend-mode: soft-light) {

.form__overlay-soft-light {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 50;
    width: 100%;
    height: 100%;
    background-color: #d4d4d4;
    mix-blend-mode: soft-light;
  }
  }

.form .form__submit-overlay--minimal .form__overlay-soft-light {
    width: 0;
    height: 0;
  }

.form__overlay-grey {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 95;
    width: 100%;
    height: 100%;
    background-color: #f6f7f8;
    opacity: 0.7;
    opacity: 0.5;
  }

.form__footer {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    align-items: center;
    justify-content: space-between;
    margin-top: 1rem;
  }

@media (width <= 640px) {

.form__footer--left-aligned {
        flex-direction: column-reverse;
        align-items: flex-start
    }
      }

.form__footer__left-column {
      display: flex;
      flex-grow: 1;
      gap: 1rem;
      align-items: center;
      justify-content: space-between;
    }

.form__footer__left-column--left-aligned {
        flex-wrap: wrap;
        justify-content: flex-start;
      }

.form__footer a.cancel-button {
      margin-left: 0;
    }

.form__footer__submit--full-width {
        flex-basis: 100%;
      }

.form__cancel {
    margin-left: calc(2rem);
  }

.form__subheading {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
